import { FormControl } from '@mui/material';
import { FC, ReactNode } from 'react';
import Text from '../text';

interface Props {
  disabled?: boolean;
  children: ReactNode;
}

const FormLabel: FC<Props> = ({ disabled, children }) => (
  <FormControl margin="normal">
    <Text bold color={disabled ? 'grey' : 'black'}>
      {children}
    </Text>
  </FormControl>
);

export default FormLabel;
